<div class="header-logo">
    <a routerLink="/" target="_blank">
        @if (!appSession.tenant || !appSession.tenant.logoId) {
            <img
                alt="Logo"
                src="/assets/common/images/app-logo-on-dark.svg"
                class="logo-default max-h-40px"
                height="38"
            />
        }
        @if (!appSession.tenant || !appSession.tenant.logoId) {
            <img
                alt="Logo"
                src="/assets/common/images/app-logo-on-light.svg"
                class="logo-sticky max-h-40px"
                height="38"
            />
        }
        @if (appSession.tenant && appSession.tenant.logoId) {
            <img
                alt="Logo"
                [src]="
                    remoteServiceBaseUrl +
                    '/TenantCustomization/GetTenantLogo?skin=' +
                    currentTheme.baseSettings.menu.asideSkin +
                    '&tenantId=' +
                    appSession.tenant.id +
                    '&id=' +
                    appSession.tenant.logoId
                "
                class="logo-default max-h-40px"
                height="38"
            />
        }
        @if (appSession.tenant && appSession.tenant.logoId) {
            <img
                alt="Logo"
                [src]="
                    remoteServiceBaseUrl +
                    '/TenantCustomization/GetTenantLogo?skin=' +
                    currentTheme.baseSettings.menu.asideSkin +
                    '&tenantId=' +
                    appSession.tenant.id +
                    '&id=' +
                    appSession.tenant.logoId
                "
                class="logo-sticky max-h-40px"
                height="38"
            />
        }
    </a>
</div>
